export const selectAttendanceRecords = (state) =>
  state.attendanceRecords?.attendanceRecords || [];

export const selectAttendanceRecordsLoading = (state) =>
  state.attendanceRecords?.loading || false;

export const selectAttendanceRecordsError = (state) =>
  state.attendanceRecords?.error || null;

export const selectAttendanceRecordsPagination = (state) =>
  state.attendanceRecords?.pagination || {};
